export default __webpack_public_path__ + "static/media/chats.a324dd1d.svg";